// extracted by mini-css-extract-plugin
export default {"material_card":"Equipment_material_card__vfDu3","active":"Equipment_active__PiP37","shimmer":"Equipment_shimmer__CxqVv"};